import { Component, OnInit } from '@angular/core';
import { MatomoInjector } from 'ngx-matomo';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AppConfigService } from 'src/app/shared/service/app-config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  title;
  lang;
  DownLoadFlag: string;
  Intranetdsata: any;
  isShowinfo: boolean = false;
  isShowinfo1: boolean = false;
  constructor(
    private ConfigService: AppConfigService,
    private idle: Idle,
    private keepalive: Keepalive,
    private readonly matomoInjector: MatomoInjector,
    private env: EnvironmentconfigService,
    private auth: AuthService) {
    // 设置闲置超时为30分钟
    idle.setIdle(30 * 60);
    // 设置超时后自动登出的超时时间为5秒
    idle.setTimeout(5);
    // 设置默认的中断事件，如点击、滚动、触摸等
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.logout();
    });

    idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone idle!');

    idle.onTimeoutWarning.subscribe((countdown) => this.idleState = 'You will time out in ' + countdown + ' seconds!');

    // sets the ping interval to 15 minutes
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.reset();

  }

  ngOnInit() {
    this.matomo();
  }



  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  logout() {
    this.auth.logoutAndClearAll();
  }

  matomo() {
    const url = this.env.authConfig.matomoURL;
    const id = Number(`${this.env.authConfig.matomoID}`);
    this.matomoInjector.init(url, id);
  }

}
